<template>
  <div class="users">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2 ">
      <h2 class="mb-0 main-title">Users/Teams</h2>
      <div class="d-flex align-items-center gap-2">
     <button 
      type="button" 
      class="btn btn-md btn-primary fs-11 fw-normal text-white"
      @click="openCreateModal"
    >
      <i class="bi bi-pencil-square"></i> Create User
    </button>

    <CreateUser 
      :show="showCreateModal"
      @close="closeCreateModal"
      @created="onUserCreated"
    />
        <button type="button" class="btn btn-md btn-outline-primary fs-11 fw-normal text-primary hover-white"> <i
            class="fa fa-list fs-11 text-primary hover-white "></i> Users List</button>
      </div>
    </div>
    
    <!-- Sirf Filters Bar -->
    <div class="filters-wrapper">
      <div class="filters-bar" id="filtersBar"></div>
      <button @click="resetAllFilters" class="btn btn-sm btn-outline-danger reset-btn fs-12 hover-white">
        <span class="material-symbols-outlined fs-13">undo</span> Reset
      </button>
    </div>

    <!-- Dropdown Template -->
    <div id="genericFilterDropdownTemplate" style="display: none;">
      <div class="generic-filter-dropdown">
        <div class="dropdown-header">
          <input type="text" class="filter-search-input" placeholder="Search...">
        </div>
        <div class="dropdown-body filter-options-container"></div>
        <div class="dropdown-footer">
          <button class="filter-clear-btn">Clear</button>
          <button class="filter-apply-btn">Apply</button>
        </div>
      </div>
    </div>

    <div class="card p-1 bg-white">
      <!-- <div class="card-body"> -->
      <!-- Table with Sorting -->
      <!-- Table with Pagination -->
      <div class="table-wrapper ">

        <table class="data-table">
          <thead>
            <tr>
              <th @click="sortBy('name')" class="sortable">
                Name <i :class="getSortIcon('name')"></i>
              </th>
              <th @click="sortBy('id')" class="sortable">
                ID <i :class="getSortIcon('id')"></i>
              </th>
              <th @click="sortBy('role')" class="sortable">
                Role <i :class="getSortIcon('role')"></i>
              </th>
              <th @click="sortBy('updatedAt')" class="sortable">
                Updated At <i :class="getSortIcon('updatedAt')"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in paginatedData" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.id }}</td>
              <td>{{ item.role }}</td>
              <td>{{ item.updatedAt }}</td>
            </tr>
            <tr v-if="paginatedData.length === 0">
              <td colspan="4" class="text-center">No data found</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
      <div class="pagination-wrapper" v-if="totalPages > 1">
        <div class="pagination-info">
          <!-- Showing {{ startIndex + 1 }} to {{ endIndex }} of {{ sortedData.length }} entries -->
        </div>
        <div class="pagination-controls">
          <button @click="prevPage" :disabled="currentPage === 1" class="pagination-btn">
            <i class="fas fa-chevron-left"></i>
          </button>

          <div class="page-numbers">
            <button v-for="page in displayedPages" :key="page" @click="goToPage(page)"
              :class="['page-btn', { active: currentPage === page }]">
              {{ page }}
            </button>
          </div>

          <button @click="nextPage" :disabled="currentPage === totalPages" class="pagination-btn">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>

      <!-- Page Size Selector -->
      <div class="page-size-wrapper">
        <label class="page-size-label">Rows per page:</label>
        <select v-model="pageSize" @change="resetPagination" class="page-size-select">
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
        </select>
      </div>
      <!-- </div> -->
    </div>
    <!-- Bootstrap 5 Modal with thin header + Select2 multiple integration -->
    <div class="modal fade" id="createUserModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="createUserModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content modal-thin-header">
          <div class="modal-header">
            <h5 class="modal-title" id="createUserModalLabel">
              <!-- Title will be set dynamically if needed -->
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            

            <form @submit.prevent="submit">
              <!-- First Name -->
              <div class="mb-3">
                <label class="form-label form-label-thin">First Name <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text"><i class="fas fa-user"></i></span>
                  <input type="text" class="form-control form-control-thin" name="first_name"
                    v-model="formData.first_name" placeholder="First Name" required />
                </div>
                <div class="text-hint">Enter the user's first name</div>
              </div>

              <!-- Last Name -->
              <div class="mb-3">
                <label class="form-label form-label-thin">Last Name <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text"><i class="fas fa-user"></i></span>
                  <input type="text" class="form-control form-control-thin" name="last_name"
                    v-model="formData.last_name" placeholder="Last Name" required />
                </div>
                <div class="text-hint">Enter the user's last name</div>
              </div>

              <!-- Email Address -->
              <div class="mb-3">
                <label class="form-label form-label-thin">Email Address <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                  <input type="email" class="form-control form-control-thin" name="email" v-model="formData.email"
                    placeholder="Email Address" required />
                </div>
                <div class="text-hint">Enter a valid email address</div>
              </div>

              <!-- External ID -->
              <div class="mb-3">
                <label class="form-label form-label-thin">External ID <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text"><i class="fas fa-id-card"></i></span>
                  <input type="text" class="form-control form-control-thin" name="id" v-model="formData.id"
                    placeholder="External ID" required />
                </div>
                <div class="text-hint">Unique external identifier for the user</div>
              </div>

              <!-- Password -->
              <div class="mb-3">
                <label class="form-label form-label-thin">Password <span class="text-danger">*</span></label>
                <div class="input-group">
                  <span class="input-group-text"><i class="fas fa-lock"></i></span>
                  <input type="password" class="form-control form-control-thin" name="password"
                    v-model="formData.password" placeholder="Password" required />
                </div>
                <div class="text-hint">Minimum 8 characters with at least one number and special character</div>
              </div>

              <!-- Phone (Optional) -->
              <div class="mb-3">
                <label class="form-label form-label-thin">Phone (Optional)</label>
                <div class="input-group">
                  <span class="input-group-text"><i class="fas fa-phone"></i></span>
                  <input type="text" class="form-control form-control-thin" name="phone" v-model="formData.phone"
                    placeholder="Phone (Optional)" />
                </div>
                <div class="text-hint">Contact number (optional)</div>
              </div>

              <!-- Role Selection (Optional extra field) -->
              <div class="mb-3">
                <label class="form-label form-label-thin">User Role</label>
                <select class="form-select form-select-thin" v-model="formData.role">
                  <option value="user">User</option>
                  <option value="admin">Administrator</option>
                  <option value="manager">Manager</option>
                  <option value="viewer">Viewer</option>
                </select>
                <div class="text-hint">Select user permission level</div>
              </div>

              <!-- Department (Optional extra field) -->
              <div class="mb-3">
                <label class="form-label form-label-thin">Department</label>
                <input type="text" class="form-control form-control-thin" v-model="formData.department"
                  placeholder="e.g., IT, HR, Operations" />
                <div class="text-hint">Department name (optional)</div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary btn-sm" data-bs-dismiss="modal">
              <i class="bi bi-x-circle"></i> Cancel
            </button>
            <button type="button" class="btn btn-primary text-light hover-white btn-md" @click="submit">
              <i class="bi bi-person-plus"></i> Create User
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateUser from './User/CreateUser.vue'
export default {
  components: {
    CreateUser
  },
  name: 'Users',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filterManager: null,
      // Sorting
      sortColumn: 'name',
      sortOrder: 'asc',
      // Pagination
      currentPage: 1,
      pageSize: 10,
      // Data
      allData: [
        { id: "#USR001", name: "John Anderson", role: "Admin", updatedAt: "2024-05-20 10:30 AM" },
        { id: "#USR002", name: "Sarah Mitchell", role: "Manager", updatedAt: "2024-05-19 03:45 PM" },
        { id: "#USR003", name: "David Chen", role: "User", updatedAt: "2024-05-18 08:15 AM" },
        { id: "#USR004", name: "Emily Rodriguez", role: "Admin", updatedAt: "2024-05-17 02:20 PM" },
        { id: "#USR005", name: "Michael Brown", role: "User", updatedAt: "2024-05-16 11:00 AM" },
        { id: "#USR006", name: "Jessica Lee", role: "Manager", updatedAt: "2024-05-15 04:30 PM" },
        { id: "#USR007", name: "Robert Taylor", role: "User", updatedAt: "2024-05-14 09:45 AM" },
        { id: "#USR008", name: "Amanda White", role: "Admin", updatedAt: "2024-05-13 01:15 PM" },
        { id: "#USR009", name: "Christopher Green", role: "User", updatedAt: "2024-05-12 07:20 AM" },
        { id: "#USR010", name: "Lisa Johnson", role: "Manager", updatedAt: "2024-05-11 05:50 PM" },
        { id: "#USR011", name: "James Williams", role: "User", updatedAt: "2024-05-10 10:00 AM" },
        { id: "#USR012", name: "Maria Garcia", role: "Admin", updatedAt: "2024-05-09 03:30 PM" }
      ],
      filteredData: [],
      selectedFiles: [],
      formData: {
        id: '',
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        phone: ''
      },
      loading: false,
      submittedData: null,
      modalInstance: null,
      select2Instance: null,
      showCreateModal: false,  // Add this data property
      // Validation errors
      errors: {}
    };
  },
  computed: {


    // Sorted data
    sortedData() {
      let result = [...this.filteredData];

      if (this.sortColumn) {
        result.sort((a, b) => {
          let valA = a[this.sortColumn];
          let valB = b[this.sortColumn];

          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';

          if (this.sortColumn === 'id') {
            valA = parseInt(String(valA).replace('#', '')) || 0;
            valB = parseInt(String(valB).replace('#', '')) || 0;
          }

          if (typeof valA === 'string') valA = valA.toLowerCase();
          if (typeof valB === 'string') valB = valB.toLowerCase();

          if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1;
          if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1;
          return 0;
        });
      }

      return result;
    },

    // Total pages
    totalPages() {
      return Math.ceil(this.sortedData.length / this.pageSize);
    },

    // Current page data
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.sortedData.slice(start, end);
    },

    // Start index for display
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },

    // End index for display
    endIndex() {
      return Math.min(this.startIndex + this.pageSize, this.sortedData.length);
    },

    // Displayed page numbers (with ellipsis)
    displayedPages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const pages = [];

      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        if (current <= 3) {
          for (let i = 1; i <= 5; i++) pages.push(i);
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) pages.push(i);
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) pages.push(i);
          pages.push('...');
          pages.push(total);
        }
      }

      return pages;
    }
  },
  mounted() {

    // Initialize Bootstrap Modal instance
    const modalEl = document.getElementById('assetUpdateModal');
    if (modalEl) {
      this.modalInstance = new bootstrap.Modal(modalEl, {
        backdrop: 'static',
        keyboard: false
      });

      // When modal is hidden, destroy select2
      modalEl.addEventListener('hidden.bs.modal', () => {
        if (this.select2Instance) {
          this.select2Instance.select2('destroy');
          this.select2Instance = null;
        }
      });

      // When modal is shown, initialize Select2
      modalEl.addEventListener('shown.bs.modal', () => {
        this.initSelect2();
      });
    }

    this.filteredData = [...this.allData];

    this.$nextTick(() => {
      setTimeout(() => {
        this.initFilters();
      }, 100);
    });
  },
  watch: {
    show(val) {
      if (!val) {
        this.resetForm()
      }
    }
  },
  methods: {
    openCreateModal() {
      this.showCreateModal = true
    },
    closeCreateModal() {
      this.showCreateModal = false
    },
    onUserCreated() {
      // Handle user created (refresh list, show toast, etc.)
      console.log('User created successfully')
      this.showCreateModal = false
    },
    resetForm() {
      this.formData = {
        id: '',
        email: '',
        password: '',
        first_name: '',
        last_name: '',
        phone: ''
      }
      this.loading = false
    },

    async submit() {
      this.loading = true

      const result = await form_api_submit({
        url: 'users/create',
        method: 'POST',

        data: this.formData,
        curr_form_id: '#createUserForm',
        // show_success_toast: true,
        // show_error_toast: true,
        // successMessage: 'User created successfully!'
      })

      if (result.success) {
        this.$emit('created')
        this.$emit('close')
        // $("model")
      }
      else {
        // Show error message (for non-validation errors)
        // this.$toast(result.message || 'Login failed', false);
      }

      this.loading = false
    },

    initFilters() {
      if (typeof $ === "undefined" || typeof GenericFilterManager === "undefined") return;

      this.filterManager = new GenericFilterManager({
        containerId: "filtersBar",
        filters: [
          {
            key: "id",
            label: "ID",
            type: "input",
            placeholder: "Filter by ID"
          },
          {
            key: "role",
            label: "Role",
            type: "checkbox",
            options: [
              { value: "admin", label: "Admin" },
              { value: "manager", label: "Manager" },
              { value: "user", label: "User" }
            ]
          }
        ],
        onFilterChange: (filters) => {
          this.applyFilters(filters);
        }
      });
    },

    applyFilters(activeFilters) {
      let result = [...this.allData];

      // For input type (string value)
      if (activeFilters.id) {
        result = result.filter(item =>
          item.id.toLowerCase().includes(activeFilters.id.toLowerCase())
        );
      }

      // For checkbox type (array value)
      if (activeFilters.role?.length) {
        result = result.filter(item =>
          activeFilters.role.includes(item.role.toLowerCase())
        );
      }

      this.filteredData = result;
    },

    // Sorting method
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortOrder = 'asc';
      }
      this.resetPagination(); // Reset to first page when sorting changes
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'fas fa-sort text-muted';
      }
      return this.sortOrder === 'asc' ? 'fas fa-sort-up text-primary' : 'fas fa-sort-down text-primary';
    },

    // Pagination methods
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page;
      }
    },

    resetPagination() {
      this.currentPage = 1;
    },

    resetAllFilters() {
      if (this.filterManager) {
        this.filterManager.clearAllFilters();
      }
      this.filteredData = [...this.allData];
      this.sortColumn = 'name';
      this.sortOrder = 'asc';
      this.resetPagination();
    },

    handleFileUpload(files) {
      this.selectedFiles = files;
    }
  },
  beforeDestroy() {
    if (this.filterManager) {
      this.filterManager.destroy();
    }
  }
}

</script>

<style scoped>
/* Red bottom border for validation error */
.form-floating.is-invalid input,
.form-floating.is-invalid select,
.form-floating.is-invalid textarea {
  border-color: #dc3545;
  border-bottom-width: 2px;
  border-bottom-color: #dc3545;
}

.form-floating.is-invalid input:focus,
.form-floating.is-invalid select:focus,
.form-floating.is-invalid textarea:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

.error-message {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  margin-left: 4px;
  text-align: left;
}
</style>